import React, { useCallback } from 'react'
import { Box, Skeleton as MuiSkeleton, Typography } from '@mui/material'
import { commify, formatUnits } from 'ethers/lib/utils'
import { erc20ABI, useBalance, useContractRead } from 'wagmi'
import { useAtomValue } from 'jotai'
import { TICKERS_MAP_BY_NAME } from '@/constants/token'
import { TargetChainAtom, TickerAtom } from '@/components/common/atoms'
import { getVaultContractAddress } from '@/utils/contract'
import { shouldUseValutContract } from '@/utils'

const Skeleton = () => <MuiSkeleton sx={{ height: 39, width: { xs: 120, md: 200 } }} />
const TextSx = {
  fontSize: '30px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
}

const CrossChainAmount = () => {
  const tickerName = useAtomValue(TickerAtom)
  const ticker = TICKERS_MAP_BY_NAME[tickerName]

  const targetChain = useAtomValue(TargetChainAtom)

  const { data: balance, isFetching: isBalanceFetching } = useBalance({
    token: ticker.erc20Tokens[targetChain]?.address,
    address: getVaultContractAddress(targetChain),
    chainId: targetChain,
    enabled: shouldUseValutContract(tickerName) && !!ticker.erc20Tokens[targetChain]?.address,
  })

  const { data: totalSupply, isFetching: isTotalSupplyFetching } = useContractRead({
    address: ticker.erc20Tokens[targetChain]?.address,
    abi: erc20ABI,
    functionName: 'totalSupply',
    chainId: targetChain,
    enabled: !shouldUseValutContract(tickerName) && !!ticker.erc20Tokens[targetChain]?.address,
  })

  const renderCorssChainAmount = useCallback(() => {
    if (shouldUseValutContract(tickerName)) {
      if (isBalanceFetching) {
        return <Skeleton />
      } else if (balance) {
        return <Typography sx={TextSx}>{commify(balance.formatted)}</Typography>
      } else {
        return <Typography sx={TextSx}>-</Typography>
      }
    }

    if (!shouldUseValutContract(tickerName)) {
      if (isTotalSupplyFetching) {
        return <Skeleton />
      } else if (totalSupply) {
        return (
          <Typography sx={TextSx}>
            {commify(Number(formatUnits(totalSupply, ticker.erc20Tokens[targetChain]?.decimal || 18)).toFixed(2))}
          </Typography>
        )
      } else return <Typography sx={TextSx}>-</Typography>
    }

    return <Typography sx={TextSx}>-</Typography>
  }, [balance, isBalanceFetching, isTotalSupplyFetching, targetChain, ticker.erc20Tokens, tickerName, totalSupply])

  return <Box sx={{ mt: 20 }}>{renderCorssChainAmount()}</Box>
}

export default CrossChainAmount
